// export const permissionsKeys = {
//   page: 'micro-sites.procedures-page',
//   pageBlockFind: 'micro-sites.procedures-page.page-block.find',
//   pageBlockCreateDefault: 'micro-sites.procedures-page.page-block.createDefault',
//   pageBlockUpdate: 'micro-sites.procedures-page.page-block.update',
//   pageBlockPreview: 'micro-sites.procedures-page.page-block.preview',
//   pageBlockUpdateInactivate: 'micro-sites.procedures-page.inactivate.page-block.update',
//   pageBlockUpdateActive: 'micro-sites.procedures-page.active.page-block.update',
// };

// 81:"param.parameters-module.parameter.find"
// 82:"param.parameters-module.parameter.update"
// 83:"param.parameters-module.parameter.remove"
// 84:"param.parameters-module.parameter.create"

export const permissionsKeys = {
  page: 'param.parameters-module.parameter',
  pageBlockFind: 'param.parameters-module.parameter.find',
  pageBlockCreate: 'param.parameters-module.parameter.create',
  pageBlockUpdate: 'param.parameters-module.parameter.update',
  pageBlockRemove: 'param.parameters-module.parameter.remove',
} as const;
